// MM Banner Start
document.addEventListener('DOMContentLoaded', function() {
    var imgElement = document.querySelector('.mm_main_banner .left_img');
    imgElement.classList.add('show');
});
  document.addEventListener('DOMContentLoaded', function() {
      var imgElement = document.querySelector('.mm_main_banner .right_img');
      imgElement.classList.add('show');
  });

// MM Banner End

// ks content start video

  document.addEventListener('DOMContentLoaded', function(){
    var video = document.querySelector('.video_element');
    var playButton = document.querySelector('.play');

    playButton?.addEventListener('click', function(){
      video.muted = false;
      video.play();
      playButton.style.display = 'none';
    });

    video?.addEventListener('play', function() {
      video.muted = false;
      playButton.style.display = 'none';
    });
  });

// ks content end video
document.addEventListener("DOMContentLoaded", () => {
  const contentInner = document.querySelector('.content_inner');
  if (contentInner) {
      contentInner.classList.add('show');
  }
});
// ks content end


// Counter Number
function animateValue(element, start, end, duration) {
  let range = end - start;
  let current = start;
  let increment = end > start ? 1 : -1;
  let stepTime = Math.abs(Math.floor(duration / range));
  let timer = setInterval(function() {
    current += increment;
    let suffix = element.innerHTML.includes('K') ? '<strong>K</strong>' : '<strong>+</strong>';
    element.innerHTML = current + suffix;
    if (current === end) {
      clearInterval(timer);
    }
  }, stepTime);
}
document.addEventListener('DOMContentLoaded', function() {
  const counters = document.querySelectorAll('.counter_number h3');
  counters.forEach(counter => {
    const text = counter.textContent.trim();
    const endValue = parseInt(text.replace(/\D/g, ''), 10);
    const startValue = 0;
    animateValue(counter, startValue, endValue, 2000);
  });
});

// counter number end


// MM about content start
document.addEventListener("DOMContentLoaded", () => {
  const $tabs = $('.mm__collection_tabs .mm__tabs_nav li');
  const $select = $('.mm__collection_tabs .mm__tabs_select');
  const $contentCols = $('.mm__collection_tabs .content_col');
  let currentTab = 0;

  function showTab(index) {
    $tabs.removeClass('active');
    $tabs.eq(index).addClass('active');
    $contentCols.hide();                  // Hide all content columns
    $contentCols.eq(index).show();
    $select.val(index);                  // Update the select element to match the clicked tab
  }

  function showTabFromSelect(index) {
    showTab(index);
  }

  showTab(currentTab);

  $tabs.click(function () {
    currentTab = $(this).index();
    showTab(currentTab);
  });

  $select.change(function () {
    currentTab = $(this).val();
    showTabFromSelect(currentTab);
  });

  // Drag functionality for tabs navigation
  let mouseDown = false, startX, scrollLeft;
  const slider = document.querySelector('.mm__collection_tabs .mm__tabs_nav');
  if (slider) {
    const startDragging = e => {
      mouseDown = true;
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    };
    const stopDragging = () => mouseDown = false;
    const move = e => {
      if (!mouseDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      slider.scrollLeft = scrollLeft - (x - startX);
    };
    slider.addEventListener('mousemove', move);
    slider.addEventListener('mousedown', startDragging);
    slider.addEventListener('mouseup', stopDragging);
    slider.addEventListener('mouseleave', stopDragging);
  }
});

// Tabs With Slider End

// MM Testimpmoial Slider
document.addEventListener('DOMContentLoaded', function() {
  $('.tm--slider-section .block_slider').slick({
    dots: true,
     arrows: true,
     draggable: false,
    speed: 500,
    slidesToShow: 3,
    prevArrow: $('.custom-prev'),
    nextArrow: $('.custom-next'),
    slidesPerView: 1.5,
    pauseOnFocus: false,
    pauseOnHover: false,
    spaceBetween: 30,
    autoplay: 3000,
    responsive: [
        {
        breakpoint: 992,
        settings: {
          slidesToShow: 2
        }
      },
          {
        breakpoint: 768,
        settings: {
          slidesToShow: 1
        }
      },
    ]
  });
});

document.addEventListener('DOMContentLoaded', function() {
  var imageElement = document.querySelector('.tm--slider-section .image');
  setTimeout(function() {
    imageElement.classList.add('animate');
  }, 500);
});
// MM Testimpmoial Slider End

// MM about banner
document.addEventListener('DOMContentLoaded', function() {
  var imgElement = document.querySelector('.col_right .video_wrapper');
  imgElement?.classList.add('show');
});
// MM about banner end


// MM Product deatils start

document.addEventListener('DOMContentLoaded', function() {
  var tabButtons = document.querySelectorAll(".tablink");
  tabButtons.forEach(function(button) {
      button.addEventListener("click", function(event) {
          var tabName = event.currentTarget.getAttribute("data-tab");
          openTab(event, tabName);
      });
  });
  var activeTabButton = document.querySelector('.tablink.active');
  if (activeTabButton) {
      activeTabButton.click();
  }
});
function openTab(evt, tabName) {
  var tabcontent = document.getElementById(tabName);
  if (!tabcontent) {
      console.error('Tab content with ID ' + tabName + ' not found.');
      return;
  }
  var allTabContents = document.getElementsByClassName("tabcontent");
  for (var i = 0; i < allTabContents.length; i++) {
      allTabContents[i].style.display = "none";
  }
  var allTabLinks = document.getElementsByClassName("tablink");
  for (var i = 0; i < allTabLinks.length; i++) {
      allTabLinks[i].classList.remove("active");
  }
  tabcontent.style.display = "block";
  evt.currentTarget.classList.add("active");
}
// MM Product deatils end




// MM collection start
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.dropdown-child').forEach((child_nav) => {
    child_nav.style.display = 'none';
  });

  document.querySelectorAll('.menu-link').forEach((nav) => {
    nav.addEventListener('click', function(event) {
      if (event.target.tagName.toLowerCase() === 'a') {
        return;
      }

      const childDropdown = this.querySelector('.dropdown-child');
      if (childDropdown) {
        event.preventDefault();
        this.classList.toggle('active');
        if (this.classList.contains('active')) {
          childDropdown.style.display = 'block';
        } else {
          childDropdown.style.display = 'none';
        }
      } else {
        window.location.href = this.querySelector('a').href;
      }
    });
  });
});

document.addEventListener('DOMContentLoaded', (event) => {
  let svg = document.querySelector('.equilizer_svg');
  let mobileMenu = document.querySelector('.mobile_menu');
  let closeSvg = document.querySelector('.close_svg');

  svg?.addEventListener('click', function(event) {
    this.classList.toggle('active');
    if (this.classList.contains('active')) {
      if (mobileMenu) {
        mobileMenu.style.display = 'block';
      }
      if(closeSvg){
        closeSvg.style.display = 'block';
      }
    } else {
      mobileMenu.style.display = 'none';
      closeSvg.style.display = 'none';
    }
    event.stopPropagation();
  });

  document.body.addEventListener('click', function() {
    svg?.classList.remove('active');
    if (mobileMenu) {
      mobileMenu.style.display = 'block';
    }
    if(closeSvg){
      closeSvg.style.display = 'none';
    }
  });

  mobileMenu?.addEventListener('click', function(event) {
    event.stopPropagation();
  });

  let menuLinks = document.querySelectorAll('.menu-link');
  menuLinks.forEach(link => {
    let childMenu = link.querySelector('.dropdown-child');
    if (childMenu) {
      link.classList.add('has-child');
    }
    link.addEventListener('click', function(event) {
      if (childMenu) {
        childMenu.classList.toggle('show');
        event.stopPropagation();
      }
    });
  });

  document.body.addEventListener('click', function() {
    let openChildMenus = document.querySelectorAll('.dropdown-child.show');
    openChildMenus.forEach(menu => {
      menu.classList.remove('show');
    });
  });
});

// MM collection end


// mm-texas-video js
document.addEventListener('DOMContentLoaded', function(){
  var video = document.querySelector('.video_element');
  var playButton = document.querySelector('.play');
  function playVideo() {
    video.play();
    playButton.style.display = 'none';
  }
  playButton?.addEventListener('click', playVideo);
  video?.addEventListener('play', function() {
    playButton.style.display = 'none';
  });
});

